<template>
  <CDialog
    :visible.sync="currentVisible"
    :title="$t('Create group')"
    width="640px"
    submittable
    :submit-label="$t('Submit')"
    :submit-disabled="submitBtnDisabled"
    :submit-loading="submitBtnLoading"
    @open="open"
    @submit="onSubmit"
  >
    <form @submit.prevent="onSubmit()">
      <section>
        <div class="form-group">
          <label for="groupName">{{ $t('Group name') }}</label>
          <input
            v-validate="'required'"
            name="name"
            maxlength="20"
            v-model="groupName"
            type="text"
            id="groupName"
            class="form-control"
            :class="{ input: true, 'is-danger': errors.has('name') }"
          />
          <span v-show="errors.has('name')" class="help is-danger">{{
            $t('Group name is required.')
          }}</span>
        </div>

        <MultiSelect
          v-model="selectedAccounts"
          :items="accounts"
          labelField="account_name"
          valueField="account_id"
          subject="account"
          :title="$t('Accounts')"
        />
      </section>
    </form>
  </CDialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CDialog from '@/components/uikit/CDialog';
import IconRadioBox from '@/components/uikit/IconSelectBox';
import Button from '@/components/uikit/Button';
import InfoWall from '@/components/uikit/InfoWall';
import MultiSelect from '@/components/MultiSelect';

const messages = {
  en: {
    'Create group': 'Create group',
    'Group name': 'Group name',
    'Group name is required.': 'Group name is required.',
    Accounts: 'Accounts',
    Submit: 'Submit',
  },
  ja: {
    'Create group': 'グループの作成',
    'Group name': 'グループ名',
    'Group name is required.': 'グループ名は必須です。',
    Accounts: 'アカウント',
    Submit: '作成する',
  },
};

export default {
  name: 'DialogCreateGroup',
  i18n: { messages },
  components: {
    CDialog,
    IconRadioBox,
    Button,
    InfoWall,
    MultiSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groupName: '',
      selectedAccounts: [],
      submitBtnLoading: false,
    };
  },
  computed: {
    ...mapGetters('accounts', { accounts: 'getAccounts' }),

    currentVisible: {
      set(value) {
        this.$emit('input', value);
      },
      get() {
        return this.value;
      },
    },

    submitBtnDisabled() {
      if (this.groupName.trim().length === 0) {
        return true;
      }

      if (this.selectedAccounts.length > 0) {
        return false;
      }

      return true;
    },
  },
  methods: {
    ...mapActions('accounts', {
      fetchAccounts: 'fetchAccounts',
    }),

    ...mapActions('groups', {
      createGroup: 'create',
    }),

    open() {
      this.groupName = '';
      this.selectedAccounts = [];
      this.$validator.reset();
      this.fetchAccounts({ force: false });
    },

    onSubmit() {
      this.$validator.validate().then(result => {
        if (!result) {
          return;
        }

        let datasets = {
          type: 'account',
          name: this.groupName,
          data: this.selectedAccounts.map(acc => acc.account_id),
        };

        this.submitBtnLoading = true;
        this.createGroup(datasets)
          .then(() => {
            this.currentVisible = false;
            this.submitBtnLoading = false;
            this.$message({
              message: this.$t('notification.group_added'),
              type: 'success',
            });
          })
          .catch(() => {
            this.$message.error('Error');
            this.submitBtnLoading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  margin-bottom: 50px;
}

.form-group > label {
  font-weight: 500;
}

.create-group-header {
  margin-bottom: 20px;
}
</style>
